
<nav class="m-0 p-1 ps-2 pe-2 navbar navbar-expand-lg bg-light border-0">   
    <a class="p-0 navbar-brand" routerLink="">
        <img id="logoNibo" src="../../../../assets/logo-nibo.png">
    </a>
    <div class="ms-auto d-flex align-items-center gap-2">          
        <span class="p-0 m-0 navbar-text" *ngIf="isUserAuthenticated()">
            Bem-vindo(a), {{userProfile()?.displayName}}
        </span>
        <button class="btn btn-outline-primary" *ngIf="!isUserAuthenticated()" (click)="login()">Login</button>          
        <button class="btn btn-outline-primary" *ngIf="isUserAuthenticated()" (click)="logout()">Logout</button>
      </div>   
</nav>







































<!-- <!DOCTYPE html>
<html>    
    <body class="container" >        
        <header class="header">           
            <nav id="nav">
                <a routerLink="/"><h1 id="title">Nibo Infra</h1></a>
                <ul>
                    <a routerLink="/">
                        <li class="navbarItem">
                            <span>VPN</span>
                        </li> 
                    </a>
                    <a routerLink="/pulumi">                        
                        <li class="navbarItem">
                            <span>Pulumi</span>
                        </li>                       
                    </a>                    
                </ul>
            </nav>                                
        </header>
    </body>
</html> -->
